module.exports = __webpack_public_path__ + "static/img/124.78af718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/124.png
// module id = MHEz
// module chunks = 0